<mat-toolbar class="no-print">
  <mat-toolbar-row>
    <div class="flex-container">
      <div class="action-buttons flex-item">
        @if (routeTerminals) {
          <terminals-actions></terminals-actions>
        }
      </div>

      <a class="navbar-brand flex-item central-objekt" [routerLink]="['/terminals']">
        <img src="../../../assets/Logo_quadratisch.png" style="height: 40px;" />
        <span style="margin-left: 10px;">ZE Terminal</span>
      </a>

      <button mat-icon-button class="btn btn-outline-primary flex-item" style="margin-left: auto;" (click)="logout()"
        placement="bottom" ngbTooltip="Abmelden" container="body" tooltipClass="myTooltip" triggers="hover" [class.hidden]="!isLogin">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-toolbar-row>

</mat-toolbar>

